import { useCallback } from 'react';
import {
  getGapWaiverEligibility,
  resetGapWaiver,
  declineGapWaiver
} from '|/services/purchase-manager';

/**
 * Custom hook for managing GAP waiver eligibility and actions
 */
const useGapWaiverData = () => {
  // Check if GAP waiver modal should be shown after order placement failure
  const shouldShowGapWaiverModal = useCallback(async (legacySummary: any): Promise<boolean> => {
    const isGapWaiverSelected = legacySummary?.gap?.status === 'Applied' || false;

    if (!isGapWaiverSelected) {
      return false;
    }

    const abortController = new AbortController();

    try {
      // Check if still eligible for GAP waiver
      const eligibilityResponse = await getGapWaiverEligibility(abortController.signal);

      if (eligibilityResponse.isAvailable) {
        return false; // Still eligible, don't show modal
      }

      // Not eligible anymore, need to remove GAP waiver
      // Must call both decline AND reset since changing terms requires customer to review again
      try {
        await declineGapWaiver(abortController.signal);
        await resetGapWaiver(abortController.signal);
        return true; // Show modal to inform user
      } catch {
        return false; // If either fails, don't show modal
      }
    } catch {
      return true; // On error, assume eligibility unknown and show modal
    }
  }, []);

  return {
    shouldShowGapWaiverModal
  };
};

export default useGapWaiverData;
